import { Page } from 'layouts/Page';
import { FC } from 'react';
import { VatReimbursement } from 'components/VatReimbursement';

export const VatReimbursementManagementPage: FC = () => {
	return (
		<Page title="Vat Reimbursement Management – EAS Control Center">
			<VatReimbursement />
		</Page>
	);
};
